const appService = async (code, params, isLoading=true) => {
  const result = await window.JsBridge.runServices('MainPage',{code},params ? [params] : [],isLoading);
  if (result.status > 0) {
    return result;
  } else {
    return false;
  }
}

export default appService;